import { CategoryType } from 'src/graphql';

export const effectiveCategory = (
  category: CategoryType,
  currentCategory: CategoryType | null,
  isCurrentCategory: boolean,
): CategoryType =>
  isCurrentCategory && currentCategory?.id === category.id
    ? currentCategory
    : category;
